__turbopack_context__.v({
  "Container": "snap-carousel-module__hu0ZzG__Container",
});
